import React from 'react';

export interface ErrorOverlayProps {
  error: Error | null;
  height?: string;
}

export function ErrorOverlay({ error, height = '100%' }: ErrorOverlayProps): JSX.Element | null {
  if (!error) return null;

  return (
    <div
      style={{
        width: '100%',
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 12,
        backgroundColor: '#101820',
        color: '#e05566',
        fontSize: 13,
        padding: '0 16px',
        textAlign: 'center',
        boxSizing: 'border-box',
      }}
    >
      {error.message || String(error)}
    </div>
  );
}
